import { render, staticRenderFns } from "./MaterialUpload.vue?vue&type=template&id=20b1fc74&scoped=true&"
import script from "./MaterialUpload.vue?vue&type=script&lang=js&"
export * from "./MaterialUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b1fc74",
  null
  
)

export default component.exports